<nb-card class="mb-0 cost-layers-dialog">
  <nb-card-header>
    {{ 'INVOICE_IMPORTS.PHASE2.COST_LAYERS_TITLE' | translate }}
    <span class="small text-muted ms-1" *ngIf="productName">— {{ productName }}</span>
  </nb-card-header>
  <nb-card-body>
    <div class="alert alert-danger" *ngIf="loadError">{{ loadError }}</div>
    <div *ngIf="payload as p">
      <div class="row g-2 small mb-3">
        <div class="col-md-6">
          <strong>{{ 'INVOICE_IMPORTS.PHASE2.COST_PRICE_SOURCE_LABEL' | translate }}:</strong>
          {{ costPriceSourceLabel() }}
        </div>
        <div class="col-md-6">
          <strong>{{ 'INVOICE_IMPORTS.PHASE2.CURRENT_COST' | translate }}:</strong>
          {{ formatKr(p.costPrice) }} kr
        </div>
        <div class="col-md-6">
          <strong>{{ 'INVOICE_IMPORTS.PHASE2.INVENTORY_QTY' | translate }}:</strong>
          {{ p.inventoryQuantity ?? '—' }}
        </div>
        <div class="col-md-6">
          <strong>{{ 'INVOICE_IMPORTS.PHASE2.OPEN_UNITS' | translate }}:</strong>
          {{ p.openUnits ?? '—' }}
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-sm">
          <thead>
            <tr>
              <th>{{ 'INVOICE_IMPORTS.PHASE2.LAYER_RECEIVED' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.PHASE2.LAYER_UNITS' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.PHASE2.LAYER_REMAINING' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.PHASE2.LAYER_UNIT_COST' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.PHASE2.LAYER_SOURCE' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.PHASE2.LAYER_INVOICE' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let layer of p.layers">
              <td>{{ layer.receivedAt | date:'dd/MM/yyyy HH:mm' }}</td>
              <td>{{ layer.unitsReceived }}</td>
              <td>{{ layer.unitsRemaining }}</td>
              <td>{{ formatKr(layer.unitCostExclVat) }}</td>
              <td>{{ layerSourceLabel(layer.costSource || layer.source) }}</td>
              <td>{{ layer.invoiceNumber || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="small text-muted mb-0" *ngIf="!p.layers?.length">
        {{ 'INVOICE_IMPORTS.PHASE2.COST_LAYERS_EMPTY' | translate }}
      </p>
    </div>
  </nb-card-body>
  <nb-card-footer class="text-end">
    <button type="button" class="btn btn-outline-secondary" (click)="close()">
      {{ 'INVOICE_IMPORTS.COMMON.CANCEL' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
